<template>
	<div class="about-loyalty pb-144" :class="{ 'gift-card': gift_card }">
		<BreadCrumb />
		<div class="about-loyalty__inner container flex between">
			<div class="about-loyalty__left-col flex column" v-if="!gift_card">
				<h2 class="pangram-heavy uppercase f-34 mt-34 mb-34" v-if="windowWidth >= 1024">
					{{ _.get(true_data, 'title') }}
				</h2>
				<div
					class="about-loyalty__teaser"
					v-html="_.get(true_data, 'description')"
				></div>
			</div>

			<div class="about-loyalty__left-col flex column" v-else>
				<h2 class="pangram-heavy uppercase f-34 mt-34 mb-21">
					{{ _.get(true_data, 'title') }}
				</h2>
				<h3
					class="medium uppercase f-21 mb-34"
					v-if="_.get(true_data, 'teaser')"
				>
					{{ _.get(true_data, 'teaser') }}
				</h3>
				<div
					class="about-loyalty__teaser"
					v-html="_.get(true_data, 'description')"
				></div>
			</div>
			<h2
				class="pangram-heavy uppercase f-34 mt-34 mb-34"
				v-if="windowWidth <= 1023 && !gift_card"
			>
				{{ _.get(true_data, 'title') }}
			</h2>

			<div class="about-loyalty__right-col" v-if="!gift_card">
				<img :src="_.get(true_data, 'images[0].url')" alt="" />
			</div>

			<div class="about-loyalty__right-col" v-else>
				<!-- <img :src="_.get(true_data, 'images[0].url')" alt="" /> -->

				<swiper ref="card_swiper" :options="swiperOptions">
					<swiper-slide v-for="(item, idx) in gift_card_data" :key="idx">
						<img :src="_.get(item, 'image[0].url')" :alt="item.title" />
					</swiper-slide>

					<div class="gift-card-pagination" slot="pagination" v-if="windowWidth >= 768"></div>
				</swiper>
				<div
					class="gift-card-pagination flex column"
					slot="pagination"
					v-if="windowWidth <= 767"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import BreadCrumb from '@/components/modules/BreadCrumb';
import resize_handler from '@/mixins/resize_handler';
export default {
	mixins: [resize_handler],
	data() {
		let that = this;
		return {
			act_slide_idx: 0,
			swiperOptions: {
				direction: 'vertical',
				slidesPerView: 1,
				grabCursor: true,
				spaceBetween: 10,
				speed: 500,

				pagination: {
					el: '.gift-card-pagination',
					clickable: true,
					renderBullet(index, className) {
						return (
							'<div style="background-color: ' +
							that.gift_card_data[index].color.color +
							' " class="' +
							className +
							'"> <span class="' +
							className +
							'-inner" style="border-color: ' +
							that.gift_card_data[index].color.color +
							' "></span></div>'
						);
					},
				},

				on: {
					slideChange() {
						that.act_slide_idx = this.activeIndex;
					},
				},
			},
		};
	},
	props: {
		contentData: Object,
	},
	components: { BreadCrumb },
	mounted() {
		console.log(this.gift_card);
	},
	computed: {
		true_data() {
			return _.get(this.contentData, 'data.list[0]');
		},
		gift_card() {
			return _.get(this.contentData, 'conf.conf');
		},
		gift_card_data() {
			return _.get(this.contentData, 'data.list[0].content.tabs');
		},
	},
};
</script>

<style lang="scss">
.about-loyalty {
	&__inner {
		padding-right: 94px;
	}
	&__teaser {
		p,
		li,
		ul,
		span,
		h1,
		h2,
		h3,
		h4,
		h5 {
			// font-family: "Hm-Pangram-bold";
			font-family: 'Firago-Book';
			font-size: 14px;
			line-height: 20px;
			color: #4d4d4f;
		}

		li {
			position: relative;
			padding-left: 20px;
			&:before {
				position: absolute;
				content: '';
				top: 4px;
				left: 0;
				width: 10px;
				height: 10px;
				background-color: rgba(100, 95, 95, 0.2);
				border-radius: 50%;
			}
		}
	}
	&__left-col {
		width: 818px;
	}
	&__right-col {
		position: relative;
		width: 402px;
		height: 255px;
		margin-top: 89px;
		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
	&.gift-card {
		.about-loyalty {
			&__right-col {
				width: 496px;
				.swiper {
					&-container {
						height: 255px;
					}
					&-slide {
						width: 402px;
						height: 255px;
						position: relative;
						border-radius: 10px;
						overflow: hidden;
						img {
							position: relative;
							top: initial;
							left: initial;
							object-fit: cover;

							width: 402px;
							height: 255px;
						}
					}
				}
			}
		}
		.gift-card-pagination {
			position: absolute;
			right: 33px;
			top: 50%;
			transform: translateY(-50%);
			z-index: 10;
			.swiper-pagination-bullet {
				position: relative;
				opacity: 1;
				width: 20px;
				height: 20px;
				margin-bottom: 15px;
				&-inner {
					position: absolute;
					transition: 0.4s;
					opacity: 0;
					width: 30px;
					height: 30px;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					background: transparent;
					border-style: solid;
					border-radius: 50%;
				}
				&.swiper-pagination-bullet-active {
					.swiper-pagination-bullet-inner {
						opacity: 1;
					}
				}
			}
		}
	}
	@media (max-width: 1550px) {
		&__inner {
			position: relative;
			padding-right: 0;
		}
	}
	@media (max-width: 1440px) {
		&__left-col {
			width: 621px;
		}
		&__right-col {
			width: 372px;
			height: 236px;
			margin-top: 113px;
		}
	}
	@media (max-width: 1125px) {
		&__inner {
			padding-right: 53px;
		}
		&__left-col {
			width: 56.97167755991286%;
			h2 {
				margin-top: 0;
			}
		}
		&__right-col {
			width: 39.760348583878%;
			padding-bottom: calc(39.760348583878% / 1.57327586207);
			height: 0;
			margin-top: 135px;
			img {
				object-fit: cover;
			}
		}
	}
	@media (max-width: 1023px) {
		padding-bottom: 87px;
		&__inner {
			padding-right: 45px;
			flex-direction: column;
		}
		h2 {
			margin-bottom: 55px;
		}
		&__left-col {
			order: 2;
			width: 100%;
			margin-top: 55px;
		}
		&__right-col {
			order: 1;
			width: 65.63421828908554%;
			padding-bottom: calc(65.63421828908554% / 1.5780141844);
			margin-top: 0;
		}
	}
	@media (max-width: 767px) {
		padding-bottom: 53px;
		&__inner {
			padding-right: 17px;
			flex-direction: column;
		}
		h2 {
			margin-bottom: 34px;
			margin-top: 24px;
		}
		&__left-col {
			order: 2;
			width: 100%;
			margin-top: 34px;
		}
		&__right-col {
			order: 1;
			width: 100%;
			padding-bottom: calc(100% / 1.58091286307);
			margin-top: 0;
		}
	}

	&.gift-card {
		.about-loyalty {
			@media (max-width: 1550px) {
				&__inner {
					position: relative;
					padding-right: 0;
				}
				&__left-col {
					width: 721px;
				}
			}
			@media (max-width: 1440px) {
				&__left-col {
					width: 521px;
				}
				&__right-col {
					margin-top: 163px;
					height: auto;
				}
			}

			@media (max-width: 1125px) {
				padding-bottom: 87px;
				&__inner {
					padding-right: 45px;
					flex-direction: column;
				}
				h2 {
					margin-bottom: 55px;
				}
				&__left-col {
					order: 2;
					width: 100%;
					margin-top: 55px;
				}
				&__right-col {
					order: 1;
					padding-bottom: 0;
					margin-top: 0;
				}
			}
			@media (max-width: 1023px) {
				padding-bottom: 87px;
				&__inner {
					padding-right: 45px;
					flex-direction: column;
				}
				h2 {
					margin-bottom: 55px;
				}
				&__left-col {
					order: 2;
					width: 100%;
					margin-top: 55px;
				}
				&__right-col {
					order: 1;
					padding-bottom: 0;
					margin-top: 0;
				}
			}
			@media (max-width: 767px) {
				padding-bottom: 53px;
				&__inner {
					padding-right: 17px;
					flex-direction: column;
				}
				h2 {
					margin-bottom: 34px;
					margin-top: 24px;
				}
				&__left-col {
					order: 2;
					width: 100%;
					margin-top: 0;
				}

				&__right-col {
					width: 90%;
					order: 1;
					margin-top: 0;
					padding-bottom: calc(90% / 1.57647058824);
					position: relative;
					.swiper-container {
						position: absolute;
						top: 0;
						left: 0;
						height: 100%;
					}
					.swiper-slide {
						width: 100%;
						height: auto;
						img {
							height: 100%;
							width: 100%;
						}
					}
				}
			}
		}

		@media (max-width: 767px) {
			.gift-card-pagination {
				right: -34px;
			}
		}
	}
}
</style>
